import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "react-bootstrap";
import { ArrowDownIcon } from "../Icons/icons.component";

export function CustomBSDropdown({
  onSelect,
  selectedItem,
  config,
  hideAllOption,
  identifier,
}) {
  const { name, options, defaultOption = "" } = config;
  const placeholder = `Select ${name}`;
  const isDisabled = !options.length;

  useEffect(() => {
    if (
      !(selectedItem && selectedItem.value) &&
      defaultOption &&
      defaultOption.value
    ) {
      onSelect(defaultOption);
    }
  }, [defaultOption]);

  const isSelected = (value) => {
    return selectedItem && selectedItem.value === value;
  };

  const handleFilterClick = () => {
    if (!identifier) return;
    const selectedFilter = document.querySelector(identifier);
    if (selectedFilter) {
      document.querySelector(identifier).scrollIntoView();
    }
  };

  return (
    <div
      onClick={handleFilterClick}
      className={`${isDisabled ? "disabled" : ""}`}
    >
      <Dropdown className="customBSDropdown">
        <Dropdown.Toggle variant="default">
          <span className="ddTitle">
            {selectedItem && selectedItem.label
              ? selectedItem.label.length > 15
                ? selectedItem.label.slice(0, 15 - 1) + "…"
                : selectedItem.label
              : placeholder}
          </span>
          <ArrowDownIcon />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {!hideAllOption && (
            <Dropdown.Item
              disabled={!selectedItem}
              onClick={() => onSelect(defaultOption)}
            >
              {placeholder}
            </Dropdown.Item>
          )}
          {Array.isArray(options) &&
            options.map((opt) => {
              const { value, label } = opt;
              if (!value || !label) return null;
              return (
                <Dropdown.Item
                  className={isSelected(value) ? "selected" : ""}
                  onClick={() => onSelect(opt)}
                >
                  {label}
                </Dropdown.Item>
              );
            })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

CustomBSDropdown.propTypes = {
  config: PropTypes.instanceOf({}),
  placeHolder: PropTypes.string,
  selectedItem: PropTypes.string,
  onSelect: PropTypes.func,
  hideAllOption: PropTypes.bool,
  identifier: PropTypes.string,
};
CustomBSDropdown.defaultProps = {
  config: {
    options: [],
  },
  placeHolder: "Select",
  onSelect: () => {},
  selectedItem: null,
  hideAllOption: false,
  identifier: null,
};

export default CustomBSDropdown;
